import React, {useEffect} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {ColumnsType} from "antd/lib/table";
import {SpecimenEntity} from "../../entity/specimen-entity";
import {Modal, Table} from "antd";
import {useStore} from "../../store";
import PlantDetail from "../detail/plant-detail";

const columns: ColumnsType<SpecimenEntity> = [
    {
        title: '馆藏条码',
        width: 100,
        dataIndex: 'libraryCode',
        key: 'libraryCode',
        align:"center",
        className: "tabeTitle",
        render: (value, record, index) => {
            return <div>{`${record.libraryCode}${record.barCode}`}</div>
        }
    },
    {
        title: '中文名/学名',
        width: 100,
        dataIndex: 'specimenName',
        key: 'specimenName',
        align:"center",
        className: "tabeTitle",
    },
    {
        title: '采集地',
        width: 200,
        dataIndex: 'province',
        key: 'province',
        render: (value, record, index) => {
            return <div>{`${record.province}/${record.district}`}</div>
        },
        align:"center",
        className: "tabeTitle",
    },
    {
        title: '采集人/采集号',
        width: 200,
        dataIndex: 'gatherer',
        key: 'gatherer',
        align:"center",
        className: "tabeTitle",
        render: (value, record, index) => {
            return <div>{`${record.gatherer}/${record.gatherNumber}`}</div>
        }
    },
    {
        title: '采集日期',
        width: 100,
        dataIndex: 'gatherDate',
        key: 'gatherDate',
        align:"center",
        className: "tabeTitle",
        sorter: false
    },
    {
        title: '鉴定人',
        width: 100,
        dataIndex: 'authenticateEr',
        key: 'authenticateEr',
        align:"center",
        className: "tabeTitle",
    },
    {
        title: '鉴定日期',
        width: 100,
        dataIndex: 'authenticateDate',
        key: 'authenticateDate',
        align:"center",
        className: "tabeTitle",
    },
];

const SearchGlobalRecord:React.FC = () => {
    const {searchGlobal} = useStore();

    useEffect(() => {
    }, [])

    const onPageChange = (page: any, pageSize: any) => {
        searchGlobal.queryGlobal("1", page)
    }
    const onItemClick = (item: any) => {
        searchGlobal.setPlantDetail(item);
        searchGlobal.setRecordDetailModal(true);
    }
    const onClose = () => {
        searchGlobal.setRecordDetailModal(false);
    }
    return (<Wrapper>
        <Table
            bordered={true}
            size={"small"}
            columns={columns}
            style={{margin:"20px"}}
            rowClassName={ (type,index, intent) => {
                return index%2 === 0 ? "tableItemWhite" : "tableItemGray";
            }}
            dataSource={searchGlobal.recordDataSource}
            onRow={(record) => {
                return {
                    onClick:() =>  onItemClick(record),
                }
            }}
            scroll={{x: 1000, y:300}}
            pagination={{onChange: onPageChange, current: searchGlobal.recordPagination.pageNum, total: searchGlobal.recordPagination.total, pageSize: 5}}
        />
        <Modal
            open={searchGlobal.recordDetailModalOpen}
            onCancel={onClose}
            closable={true}
            centered={true}
            destroyOnClose={true}
            title={null}
            footer={null}
            mask={true}
            maskClosable={true}
            width={"1000px"}>
            <PlantDetail detail={searchGlobal.plantDetail}/>
        </Modal>
    </Wrapper>);
}
export default observer(SearchGlobalRecord);
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    background: white;
    .ant-table-wrapper .ant-table-thead >tr>th {
      background: #EFF3F8 ;
    }
    .tableItemWhite{
      background: white;
    }
    .tableItemGray{
      background: #F9FAFD;
    }
  }
`;